import { createSlice } from "@reduxjs/toolkit";
import { number } from "prop-types";

const initialState = {
  id: number,
};

export const ScrollByIdSlice = createSlice({
  name: "scroll",
  initialState,
  reducers: {
    scrollById: (state: any, action: any) => {
      const { id } = action.payload;
      state.id = id;
    },
  },
});

// this is for dispatch
export const { scrollById } = ScrollByIdSlice.actions;

// this is for configureStore
export default ScrollByIdSlice.reducer;
